/* Build timestamp: 1740700800 - Build 304 */
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ToastProvider } from './components/Toast';
import { Layout } from './components/Layout';
import { ModeSelector } from './pages/ModeSelector';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Products } from './pages/Products';
import { OrdersManagement } from './pages/OrdersManagement';
import { Categories } from './pages/Categories';
import { Settings } from './pages/Settings';
import { AIAssistant } from './pages/AIAssistant';
import { PromotionsV2 } from './pages/PromotionsV2';
import { Customers } from './pages/Customers';
import { Notifications } from './pages/Notifications';
import { AICampaigns } from './pages/AICampaigns';
import { CampaignHistory } from './pages/CampaignHistory';
import { AIMarketingSettings } from './pages/AIMarketingSettings';
import { Options } from './pages/Options';
import { MenuManagement } from './pages/MenuManagement';
import { Revenue } from './pages/Revenue';
import { TicketZ } from './pages/TicketZ';
import { FavoritesStats } from './pages/FavoritesStats';
import AIMarketingTemp from './pages/AIMarketingTemp';
import { OrdersMode } from './pages/OrdersMode';
import { DeliveryMode } from './pages/DeliveryMode';
import { ModeLogin } from './pages/ModeLogin';
import { AdminManagement } from './pages/AdminManagement';

// MODULE SURPRISE DU JOUR
import SurpriseDuJourDashboard from './pages/SurpriseDuJourDashboard';
import SurpriseDuJourRewards from './pages/SurpriseDuJourRewards';
import SurpriseDuJourConfiguration from './pages/SurpriseDuJourConfiguration';
import SurpriseDuJourSettings from './pages/SurpriseDuJourSettings';
import { Popups } from './pages/Popups';

// MODULE CHRONO 10.00
import ChronoGameConfig from './pages/ChronoGameConfig';
import EmailInnovorder from './pages/EmailInnovorder';

// MODULE UPSELL
import { UpsellPage } from './pages/UpsellPage';

// Layout protégé
const ProtectedLayout = () => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <Layout /> : <Navigate to="/login" replace />;
};

function AppRoutes() {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      {/* Sélection de mode (accueil) */}
      <Route path="/select-mode" element={<ModeSelector />} />
      
      {/* Login Admin */}
      <Route path="/login" element={isAuthenticated ? <Navigate to="/admin" replace /> : <Login />} />
      
      {/* Mode Commandes */}
      <Route path="/orders-mode-login" element={<ModeLogin mode="orders" />} />
      <Route path="/orders-mode" element={<OrdersMode />} />
      
      {/* Mode Livraison */}
      <Route path="/delivery-mode-login" element={<ModeLogin mode="delivery" />} />
      <Route path="/delivery-mode" element={<DeliveryMode />} />
      
      {/* Back Office protégé */}
      <Route path="/admin" element={<ProtectedLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="ai" element={<AIAssistant />} />
        <Route path="ai-marketing/campaigns" element={<AICampaigns />} />
        <Route path="ai-marketing/history" element={<CampaignHistory />} />
        <Route path="ai-marketing/settings" element={<AIMarketingSettings />} />
        <Route path="ai-marketing-temp" element={<AIMarketingTemp />} />
        <Route path="menu" element={<MenuManagement />} />
        <Route path="products" element={<Products />} />
        <Route path="options" element={<Options />} />
        <Route path="orders" element={<OrdersManagement />} />
        <Route path="revenue" element={<Revenue />} />
        <Route path="categories" element={<Categories />} />
        <Route path="promotions" element={<PromotionsV2 />} />
        <Route path="upsell" element={<UpsellPage />} />
        <Route path="customers" element={<Customers />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="settings" element={<Settings />} />
        <Route path="popups" element={<Popups />} />
        <Route path="ticket-z" element={<TicketZ />} />
        <Route path="favorites" element={<FavoritesStats />} />
        
        {/* SURPRISE DU JOUR */}
        <Route path="surprise-du-jour" element={<SurpriseDuJourDashboard />} />
        <Route path="surprise-du-jour/configuration" element={<SurpriseDuJourConfiguration />} />
        <Route path="surprise-du-jour/rewards" element={<SurpriseDuJourRewards />} />
        <Route path="surprise-du-jour/settings" element={<SurpriseDuJourSettings />} />

        {/* CHRONO 10.00 */}
        <Route path="chrono-game" element={<ChronoGameConfig />} />

        {/* EMAIL INNOVORDER */}
        <Route path="email-innovorder" element={<EmailInnovorder />} />

        {/* GESTION DES ADMINS (super_admin only) */}
        <Route path="users" element={<AdminManagement />} />
      </Route>
      
      {/* Redirection par défaut */}
      <Route path="/" element={<Navigate to="/select-mode" replace />} />
      <Route path="*" element={<Navigate to="/select-mode" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <BrowserRouter basename="/">
          <AppRoutes />
        </BrowserRouter>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
